module.exports = __webpack_public_path__ + "media/images/projects/3-dashboard-87b1d93d46f04000c2eb1766ace4fc0a.jpg";